{
	"title": "Houders",
	"description": "De houders waar een navulling op gaat, zoals standaard wissers, bekende XXL-wissers of plumeaustelen. Per variant zet je in de productbewerker of hij erop past of niet. Een merk mag je noemen, maar nooit als vergelijking.",
	"list": "Houders",
	"empty": "Er zijn nog geen houders. Maak hieronder de eerste.",
	"orderHint": "Het maatlabel noemt de houders in deze volgorde.",
	"column": {
		"position": "Plek",
		"name": "Houder",
		"variants": "Varianten",
		"actions": "Acties"
	},
	"singular": "Enkelvoud: {{name}}",
	"footSize": "Voetmaat: {{size}}",
	"variantCount_one": "{{count}} variant",
	"variantCount_other": "{{count}} varianten",
	"moveUp": "Omhoog: {{name}}",
	"moveDown": "Omlaag: {{name}}",
	"moved": "{{name}} staat nu op plek {{position}} van {{total}}.",
	"new": {
		"title": "Houder toevoegen",
		"submit": "Toevoegen"
	},
	"edit": {
		"button": "Bewerken: {{name}}",
		"title": "{{name}} bewerken",
		"submit": "Opslaan",
		"cancel": "Annuleren"
	},
	"field": {
		"name": "Naam",
		"namePlaceholder": "Bijvoorbeeld bekende XXL-wissers",
		"nameDescription": "Zoals hij in het maatlabel staat: \"past op …\" of \"niet voor …\".",
		"singularName": "Naam in het enkelvoud",
		"singularNamePlaceholder": "Bijvoorbeeld XXL-wisser",
		"singularNameDescription": "Eén houder, zoals de productpagina hem noemt: \"Dit past niet op je …\". Leeg laten mag; dan gebruikt de shop de naam hierboven.",
		"footSize": "Voetmaat",
		"footSizePlaceholder": "Bijvoorbeeld 42×12 cm",
		"footSizeDescription": "Lengte × breedte van de voet, voor de pasvormgids en de wisserpagina. Leeg laten mag; dan laat de shop hem weg.",
		"measuringTip": "Meettip",
		"measuringTipPlaceholder": "Bijvoorbeeld: Meet de voet van je wisser van links naar rechts.",
		"measuringTipDescription": "Eén of twee korte zinnen over hoe je meet. Staat bij \"Wat past\" op de wisserpagina. Leeg laten mag."
	},
	"delete": {
		"button": "Verwijderen: {{name}}",
		"title": "{{name}} verwijderen?",
		"description_one": "De houder verdwijnt, en daarmee de pasvorm van {{count}} variant. Dit kun je niet ongedaan maken.",
		"description_other": "De houder verdwijnt, en daarmee de pasvorm van {{count}} varianten. Dit kun je niet ongedaan maken.",
		"confirm": "Verwijderen",
		"categories_one": "De categorie die zijn wisserpagina is, wordt een gewone categoriepagina.",
		"categories_other": "De {{count}} categorieën die zijn wisserpagina zijn, worden gewone categoriepagina's."
	},
	"error": {
		"nameTaken": "Er is al een houder met deze naam.",
		"notFound": "Deze houder bestaat niet meer. Laad de pagina opnieuw.",
		"orderOutdated": "De lijst is intussen veranderd. Hij is opnieuw geladen; verplaats de houder nog eens."
	},
	"help": {
		"holders": {
			"title": "Houders",
			"area": "Producten › Houders",
			"short": "De houders waar een navulling op gaat, zoals standaard wissers en XXL-wissers. Per variant zet je in de productbewerker of hij erop past of niet. Het maatlabel zegt het allebei; onbekend noemt het niet.",
			"warning": "Een merk mag je noemen, zoals Swiffer, maar nooit als vergelijking: wel \"past op Swiffer-wissers\", niet \"goedkoper dan Swiffer\".",
			"terms": ["product:holder", "product:fit", "product:sizeLabel", "holder:name", "holder:fitGuide"]
		},
		"name": {
			"title": "Naam van een houder",
			"area": "Producten › Houders",
			"short": "In het meervoud, zoals het maatlabel hem noemt: \"past op XXL-wissers\", \"niet voor standaard wissers\". Het maatlabel noemt de houders in de volgorde van deze lijst.",
			"terms": ["product:sizeLabel"]
		},
		"fitGuide": {
			"title": "Voetmaat en meettip",
			"area": "Producten › Houders",
			"short": "De voetmaat staat in de pasvormgids en op de wisserpagina van de houder, de meettip bij Wat past op die wisserpagina. Zo meet een klant zijn eigen houder en ziet hij welke navulling past.",
			"terms": ["category:holderPage"]
		}
	},
	"helpExample": {
		"sizeLabel": "Voorbeeld uit de shop: het maatlabel van Floorwipes XXL. 46×27 cm, past op XXL-wissers, niet voor standaard wissers."
	}
}
